import React, { useState } from "react"
import { reduxForm, Field, reset, formValueSelector } from "redux-form"
import { FORM_NAMES } from "constants/index"
import {
  TextField,
  SingleSelectField,
  MultipleSelectField,
  CheckboxField,
} from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import { Col, Row } from "reactstrap"
import { connect } from "react-redux"
import { downloadUsersList, getCustomers } from "store/actions"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { ActionsDropdown } from "components/Dropdowns"

const HeaderLine = props => {
  const {
    handleSubmit,
    loading,
    metaTags,
    businessUnits,
    reset,
    getCustomers,
    business_unit_id,
    filter_tags,
    setFilterFormValues,
    resetCheckedItems,
    usersCSVFile,
    customers,
    downloadUsersList,
    filters,
    order,
  } = props

  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const [showResetButton, setShowResetButton] = useState(false)

  const onUploadCSV = () => {
    usersCSVFile.current.click()
  }

  const onManageDomains = () => {
    window.location.href = "/domains"
  }

  const onDownloadList = () => {
    downloadUsersList({ ...filters, ...order, dashboard: true, download: 1 })
  }

  const menuActions = [
    {
      name: "Upload CSV",
      onClick: onUploadCSV,
      icon: "bx bx-upload",
      isAvailable: true,
    },
    {
      name: "Download List",
      onClick: onDownloadList,
      icon: "bx bx-download",
      isAvailable: customers?.length > 0,
    },
    {
      name: "Manage Domains",
      onClick: onManageDomains,
      icon: "bx bx-grid-alt",
      isAvailable: true,
    },
  ]

  const resetSearch = () => {
    reset()
    setShowResetButton(false)
    setFilterFormValues(null)
    getCustomers({ o: "registered_at", od: "desc", dashboard: true })
    resetCheckedItems([])
  }

  return (
    <React.Fragment>
      <form
        onSubmit={event => {
          event.preventDefault()
          handleSubmit()
          setShowResetButton(true)
        }}
      >
        <Row>
          <Col>
            <BreadcrumbTitle
              title={"Users List"}
              breadcrumbItems={[
                { title: "Dashboard" },
                { title: "Users List" },
              ]}
            />
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-center">
            <Row className="form-group">
              <Col xs={6} sm={6} md="auto" className="my-1">
                <Field
                  name={"s"}
                  placeholder={"Search by name"}
                  component={TextField}
                />
              </Col>
              <Col xs={6} sm={6} md="auto" className="my-1">
                <SaveButton
                  content={showMoreFilters ? "Hide filters" : "More filters"}
                  color={"light"}
                  onClick={() => setShowMoreFilters(!showMoreFilters)}
                  type="button"
                  fullWidth={true}
                />
              </Col>

              <Col xs={12} sm="auto" className="d-none d-md-block my-1">
                <SaveButton content={"Search"} fullWidth={true} />
              </Col>
              {showResetButton && (
                <Col xs={12} sm="auto" className="d-none d-md-block my-1">
                  <SaveButton
                    content={"Reset"}
                    color="light"
                    fullWidth={true}
                    type="button"
                    onClick={resetSearch}
                  />
                </Col>
              )}
            </Row>
          </Col>
          <Col
            xs="auto"
            style={{ minWidth: "fit-content" }}
            className="my-1 d-none d-md-block"
          >
            <ActionsDropdown
              label={"Menu"}
              icon={"mdi mdi-dots-vertical"}
              actionsList={menuActions}
              menuPosition={"end"}
              fullWidth={true}
            />
          </Col>
        </Row>
        {showMoreFilters && (
          <Row className="px-1 py-3">
            <Col lg={4}>
              <div className={"mb-3"}>
                <Field
                  value={business_unit_id}
                  name={"business_unit_id"}
                  label={"Business Unit"}
                  component={SingleSelectField}
                  options={businessUnits.map(bu => ({
                    value: bu.id,
                    label: bu.name,
                  }))}
                />
              </div>
            </Col>
            <Col lg={4}>
              <div className={"mb-3"}>
                <Field
                  value={filter_tags}
                  name={"filter_tags"}
                  label={"Tags"}
                  component={MultipleSelectField}
                  options={metaTags.map(tag => ({
                    label: tag.tag,
                    value: tag.id,
                  }))}
                />
              </div>
            </Col>
            <Col lg={1}>
              <div className={"mb-3 inlineFormCheckbox"}>
                <Field
                  name={"active"}
                  label={"Active"}
                  component={CheckboxField}
                />
              </div>
            </Col>
            <Col lg={1}>
              <div className={"mb-3 inlineFormCheckbox"}>
                <Field
                  name={"pending"}
                  label={"Pending"}
                  component={CheckboxField}
                />
              </div>
            </Col>
          </Row>
        )}
        <Row className="d-md-none d-flex justify-content-center">
          <Col xs={showResetButton ? 6 : 12} sm={6}>
            <SaveButton content={"Search"} fullWidth={true} />
          </Col>
          {showResetButton && (
            <Col xs={6}>
              <SaveButton
                content={"Reset"}
                color="light"
                fullWidth={true}
                type="button"
                onClick={resetSearch}
              />
            </Col>
          )}
        </Row>
        <Row className="d-md-none">
          <Col xs="auto" style={{ minWidth: "fit-content" }} className="my-1">
            <ActionsDropdown
              label={"Menu"}
              icon={"mdi mdi-dots-vertical"}
              actionsList={menuActions}
              menuPosition={"start"}
              fullWidth={true}
            />
          </Col>
        </Row>
      </form>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.USERS_FILTER)

const mapStateToProps = state => ({
  business_unit_id: selector(state, "business_unit_id"),
  filter_tags: selector(state, "filter_tags"),
  customers: state.people.customers,
  metaTags: state.Tags.metaTags,
  businessUnits: state.businessUnits.businessUnits,
})

const mapDispatchToProps = dispatch => ({
  reset: () => dispatch(reset(FORM_NAMES.USERS_FILTER)),
  getCustomers: values => dispatch(getCustomers(values)),
  downloadUsersList: values => dispatch(downloadUsersList(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.USERS_FILTER,
  })(HeaderLine)
)
